import React from 'react';
import { IndexRoute, Route } from 'react-router';
import InviteContacts from './inviteContacts';
export default (
  <Route path="invite-contacts">
    <IndexRoute component={props => <InviteContacts {...props} />} />
  </Route>
);
